export default "__VITE_ASSET__xu3z5TnH__"